export default __webpack_public_path__ + "static/media/q30b_v2.d58a1bd6.png";